import React from "react";

const IconNotifications = ({
  width = "24",
  height = "24",
  active = false,
  fill = "#b8b8b8",
 className = "",
  className2 = "scale13",
}) => {
  return (
    <svg
      viewBox="0 0 20 25"
      className={className ? className : null}
      width={width}
      height={height}
      data-name="iconNotifications"
    >
      {!active ? (
        <path
          fill={fill}
          d="M10 24.5C11.375 24.5 12.5 23.375 12.5 22H7.5C7.5 23.375 8.6125 24.5 10 24.5ZM17.5 17V10.75C17.5 6.9125 15.45 3.7 11.875 2.85V2C11.875 0.9625 11.0375 0.125 10 0.125C8.9625 0.125 8.125 0.9625 8.125 2V2.85C4.5375 3.7 2.5 6.9 2.5 10.75V17L0 19.5V20.75H20V19.5L17.5 17Z"
        />
      ) : (
        <g
          stroke="none"
          strokeWidth="1"
          fill={fill}
          className={className2}
          fillRule="evenodd"
        >
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M7.58,4.08 L6.15,2.65 C3.75,4.48 2.17,7.3 2.03,10.5 L4.03,10.5 C4.18,7.85 5.54,5.53 7.58,4.08 L7.58,4.08 Z M19.97,10.5 L21.97,10.5 C21.82,7.3 20.24,4.48 17.85,2.65 L16.43,4.08 C18.45,5.53 19.82,7.85 19.97,10.5 Z"
            fill={fill}
            fillRule="nonzero"
          />
          <path
            d="M12,21.5 C13.1,21.5 14,20.6230769 14,19.5512821 L10,19.5512821 C10,20.6230769 10.89,21.5 12,21.5 Z M18,15.6538462 L18,10.7820513 C18,7.79076923 16.36,5.28666667 13.5,4.62410256 L13.5,3.96153846 C13.5,3.15282051 12.83,2.5 12,2.5 C11.17,2.5 10.5,3.15282051 10.5,3.96153846 L10.5,4.62410256 C7.63,5.28666667 6,7.78102564 6,10.7820513 L6,15.6538462 L4,17.6025641 L4,18.5769231 L20,18.5769231 L20,17.6025641 L18,15.6538462 Z"
            fill={fill}
            fillRule="nonzero"
          />
        </g>
      )}
    </svg>
  );
};

export default IconNotifications;
